import * as madnes from "./madnes";
import events from "../../events/EventsObservable";
import Wallet, {WALLET_EVENTS} from "../../wallet/Wallet";
import {AUTOSTART_EVENTS} from "../../game/GameAutostart";
import {ACTION_EVENTS} from "../../ui/UserAction";
import {GAME_EVENTS} from "../../game/gameEvents";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig from "../../system/SystemConfig";
import MadnesCommander from "../../commander/MadnesCommander";
import IApp from "../IApp";
import IInitApp from "../IInitApp";
import Fullscreen from "../../ui/screen/Fullscreen";
import IGame from "../../game/IGame";
import IStatesManager from "../../states/IStatesManager";

@injectable()
export default class InitMadnesApp implements IInitApp {

    private app: IApp;
    private config: SystemConfig;
    private commander: MadnesCommander;
    private game: IGame;
    private wallet: Wallet;
    private states: IStatesManager;
    private fullscreen: Fullscreen;

    constructor(
        @inject(SERVICE_IDENTIFIER.EngineApp) app: IApp,
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.Commander) commander: MadnesCommander,
        @inject(SERVICE_IDENTIFIER.Game) game: IGame,
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.StatesManager) states: IStatesManager,
        @inject(SERVICE_IDENTIFIER.Fullscreen) screen: Fullscreen
    ) {
        this.app = app;
        this.config = config;
        this.commander = commander;
        this.game = game;
        this.wallet = wallet;
        this.states = states;
        this.fullscreen = screen;
    }

    init() {

        events.subscribe([
            WALLET_EVENTS.WALLET_ON_INITED,
            WALLET_EVENTS.WALLET_ON_SET_BALANCE,
            WALLET_EVENTS.WALLET_ON_SET_WIN,
            WALLET_EVENTS.WALLET_ON_SET_BET,
            AUTOSTART_EVENTS.AUTOSTART_ON_SET_COUNT,

            ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_LEFT,
            ACTION_EVENTS.ACTION_GAME_CANVAS_SWIPE_RIGHT,
            GAME_EVENTS.GAME_END_ROUND
        ], madnes);

        madnes.register({
            config: this.config,
            commander: this.commander,
            game: this.game,
            wallet: this.wallet,
            statesManager: this.states,
            screen: this.fullscreen
        });
    }

}